module.exports = __webpack_public_path__ + "img/about02.97863c7f.svg";